import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';

@Component({
    selector: 'cds-input-number',
    imports: [InputNumberModule, FormsModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputNumberComponent),
            multi: true,
        },
    ],
    standalone: true,
    templateUrl: './input-number.component.html',
    styleUrl: './input-number.component.less',
})
export class InputNumberComponent implements ControlValueAccessor {
    @Input() value: number = 0;
    @Input() disabled: boolean = false;

    onChanged!: (value: number) => void;
    onTouched!: () => void;

    registerOnChange(fn: (value: number) => void): void {
        this.onChanged = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    writeValue(value: number): void {
        this.value = value;
    }

    setDisabledState(disabled: boolean): void {
        this.disabled = disabled;
    }

    handleChange() {
        this.onChanged?.(this.value);
        this.onTouched?.();
    }
}
